import { FC, ReactNode } from 'react'
import { SeatingAreaAvatar, SeatingAreaAvatarType } from './Avatar'
import { SeatingAreaOption, SeatingAreaOptionType } from './Option'
import {
  VisibilityCardForm,
  VisibilityCardFormType,
} from './VisibilityCardForm'

const SeatingArea: FC &
  SeatingAreaAvatarType &
  SeatingAreaOptionType &
  VisibilityCardFormType = (): ReactNode => <></>

SeatingArea.Avatar = SeatingAreaAvatar
SeatingArea.Option = SeatingAreaOption
SeatingArea.VisibilityCardForm = VisibilityCardForm

export default SeatingArea
